var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoosterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(-1213 -1322)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1213 1322)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "profits",
    transform: "translate(1223.154 1332.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3409",
    "data-name": "Path 3409",
    d: "M32.716,214.326h3.007L24.389,225.582l-9.3-6.977L0,233.691l1.644,1.567L15.3,221.676l9.3,6.977,12.76-12.683v3.007h2.326V212H32.716Z",
    transform: "translate(0 -195.565)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3410",
    "data-name": "Path 3410",
    d: "M199.489,78.18V60H196V75.563Z",
    transform: "translate(-180.805 -55.348)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3411",
    "data-name": "Path 3411",
    d: "M45,254.51l3.566-3.489V242H45Z",
    transform: "translate(-41.511 -223.239)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3412",
    "data-name": "Path 3412",
    d: "M124.489,161.262V151H121v13.75Z",
    transform: "translate(-111.619 -139.294)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3413",
    "data-name": "Path 3413",
    d: "M274.162,250.186l.327-.327V242H271v5.814Z",
    transform: "translate(-249.991 -223.239)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3414",
    "data-name": "Path 3414",
    d: "M349.566,20.805V0H346V24.294Z",
    transform: "translate(-319.176)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosterIcon);
export default __webpack_public_path__ + "static/media/booster-icon.c80eed006f10c8b609f1256ce75d9465.svg";
export { ForwardRef as ReactComponent };